import {
    FETCH_PIANOTECHNICIAN_LIST_STARTED,
    FETCH_PIANOTECHNICIAN_LIST_SUCCEEDED,
    FETCH_PIANOTECHNICIAN_LIST_FAILED,
    FIND_PIANOTECHNICIAN_STARTED,
    FIND_PIANOTECHNICIAN_SUCCEEDED,
    FIND_PIANOTECHNICIAN_FAILED,
    SAVE_PIANOTECHNICIAN_STARTED,
    SAVE_PIANOTECHNICIAN_SUCCEEDED,
    SAVE_PIANOTECHNICIAN_FAILED,
    RETURN_TO_PIANOTECHNICIAN_LIST,
    SWITCH_EDIT_TYPE_PIANOTECHNICIAN,
    PIANOTECHNICIAN_MODIFIED,
    PIANOTECHNICIAN_VALIDATE,
    FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_STARTED,
    FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_SUCCEEDED,
    FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_FAILED,
} from '../actions/PianoTechnicianActions';

import {
    LOGIN_VALIDATE_USER_SUCCESS
} from '../actions/LoginActions';

import {
    MESSAGE_TYPE_CONFIRM,
    MESSAGE_TYPE_ERROR,
    MESSAGE_TYPE_INFO,
    VIEW_PIANOTECHNICIAN_LIST,
    VIEW_PIANOTECHNICIAN_UPDATE,
    MAINTENANCE_TYPE_COMPLETE,
} from '../app-constants';

const initialState = {
    pianoTechnicianList: [],
    pianoTechnician: null,
    originalPianoTechnician: null,
    view: VIEW_PIANOTECHNICIAN_LIST,
};
const reducerOutput = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_PIANOTECHNICIAN_LIST_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechnician list.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechnicianList: [],
            }

        case FETCH_PIANOTECHNICIAN_LIST_SUCCEEDED:

            return {
                ...state,
                pianoTechnicianList: action.pianoTechnicianList,
                message: 'PianoTechnician list successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHNICIAN_LIST_FAILED:

            return {
                ...state,
                pianoTechnicianList: [],
                message: 'Error trying to retrieve PianoTechnician list.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case RETURN_TO_PIANOTECHNICIAN_LIST:

            return {
                ...state,
                pianoTechnician: null,
                originalPianoTechnician: null,
                message: '',
                view: VIEW_PIANOTECHNICIAN_LIST
            }

        case SWITCH_EDIT_TYPE_PIANOTECHNICIAN:

            return {
                ...state,
                maintenanceType: action.maintenanceType,
                title: action.title,
                message: '',
                pianoTechnician: action.pianoTechnician,
            }

        case FIND_PIANOTECHNICIAN_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechnician.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechnician: null,
                maintenanceType: action.maintenanceType,
                title: action.title,
            }

        case FIND_PIANOTECHNICIAN_SUCCEEDED:

            return {
                ...state,
                pianoTechnician: action.pianoTechnician,
                originalPianoTechnician: action.originalPianoTechnician,
                message: 'PianoTechnician successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
                view: VIEW_PIANOTECHNICIAN_UPDATE,
            }

        case FIND_PIANOTECHNICIAN_FAILED:

            return {
                ...state,
                pianoTechnician: null,
                message: 'Error trying to find PianoTechnician.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHNICIAN_MODIFIED:

            return {
                ...state,
                pianoTechnician: action.pianoTechnician,
                message: '',
            }

        case SAVE_PIANOTECHNICIAN_STARTED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_INFO,
            }

        case SAVE_PIANOTECHNICIAN_SUCCEEDED:

            return {
                ...state,
                pianoTechnician: action.pianoTechnician,
                pianoTechnicianList: action.pianoTechnicianList,
                message: action.message,
                messageType: MESSAGE_TYPE_CONFIRM,
                maintenanceType: MAINTENANCE_TYPE_COMPLETE,
            }

        case SAVE_PIANOTECHNICIAN_FAILED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHNICIAN_VALIDATE:

            return {
                ...state,
                message: action.message,
                messageType: action.messageType,
            }

        case FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechnician list for company.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechnicianList: [],
            }

        case FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_SUCCEEDED:

            return {
                ...state,
                pianoTechnicianList: action.pianoTechnicianList,
                message: 'PianoTechnician list for company successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHNICIAN_LIST_FOR_COMPANY_FAILED:

            return {
                ...state,
                pianoTechnicianList: [],
                message: 'Error trying to retrieve PianoTechnician list for company.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case LOGIN_VALIDATE_USER_SUCCESS:

            return {
                ...state,
                pianoTechnicianList: action.pianoTechnicianList,
            }

        default:
            return state;
    }
}


export default reducerOutput;
